module.exports = __webpack_public_path__ + "img/SK47248572.48a4af21.png";